module.exports = __webpack_public_path__ + "static/media/SlackClone.373fc6e1.png";